import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import MatelsoConsentBridge from "./components/MatelsoConsentBridge/MatelsoConsentBridge";

function Root() {
  useEffect(() => {
    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            intersectionObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
      }
    );

    const observeFadeElements = () => {
      const elements = document.querySelectorAll(
        ".fade-in-up, .fade-in, .fade-section"
      );

      elements.forEach((el) => {
        if (!el.dataset.revealBound) {
          el.dataset.revealBound = "true";
          intersectionObserver.observe(el);
        }
      });
    };

    observeFadeElements();

    const mutationObserver = new MutationObserver(() => {
      observeFadeElements();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      intersectionObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, []);

   <MatelsoConsentBridge />
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
